import { useState, useEffect } from "react"
import { api } from "aldoo-ra/API"
import { url } from "aldoo-ra/CMS/url"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const hcAPI = api("help-center")

const PopularCategories = () => {
  const texts = TextBundle({ id: "help-center" })
  const [items, setItems] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [sectionName, setSectionName] = useState("Most Popular")

  const [currentLanguage] = useState(() => {
    try {
      const stored = localStorage.getItem("current-site-language")
      return stored ? stored.replace(/"/g, "") : "en"
    } catch { return "en" }
  })

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await hcAPI({
          get_content: { contentURL: "/category/most-popular", language: currentLanguage },
        })

        const content = response?.content
        if (!content) { setItems([]); return }

        setSectionName(content.name || "Most Popular")

        const categories = (content.categories || [])
          .filter((c) => c.status === "published")
          .map((c) => ({ ...c, _type: "category" }))

        const articles = (content.articles || [])
          .filter((a) => a.status === "published")
          .map((a) => ({ ...a, _type: "article" }))

        setItems([...categories, ...articles])
      } catch {
        setItems([])
      } finally {
        setIsLoading(false)
      }
    }
    fetchItems()
  }, [currentLanguage])

  const handleCategoryClick = (slug) => {
    window.location.href = `/help-center/category/${slug}`
  }

  const handleArticleClick = (slug) => {
    if (window.loadHelpCenterContent) {
      window.loadHelpCenterContent("article", slug, null)
    } else {
      window.location.href = `/help-center/article/${slug}`
    }
  }

  if (isLoading) return (
    <div className="py-8 text-center">
      <Typography variant="txt1_dim">
        {texts?.loading_popular_cat || "Loading popular categories..."}
      </Typography>
    </div>
  )

  if (!items.length) return null

  return (
    <div>
      <Typography variant="h2" className="text-center md:text-left mb-6 md:mb-11">
        {sectionName}
      </Typography>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7">
        {items.map((item) => item._type === "category" ? (
          <div
            key={item._id}
            className="h-[186px] flex flex-col items-center justify-center bg-paper border border-bordered hover:border-secondary rounded-[30px] p-8 cursor-pointer hover:shadow-soft_lg transition-shadow"
            onClick={() => handleCategoryClick(item.slug)}
          >
            {item.icon && (
              <div className="h-[60px] w-[60px] mb-4">
                <img src={url(item.icon)} alt={`${item.label} icon`} className="h-full w-auto object-contain" />
              </div>
            )}
            <Typography variant="h4" className="text-left my-0">{item.label}</Typography>
          </div>
        ) : (
          <div
            key={item._id}
            className="h-[186px] flex flex-col items-center justify-center bg-paper border border-bordered hover:border-secondary rounded-[30px] p-8 cursor-pointer hover:shadow-soft_lg transition-shadow"
            onClick={() => handleArticleClick(item.slug)}
          >
            <Typography variant="h4" className="text-center my-0">{item.label}</Typography>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PopularCategories
